var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8166 1.81451C10.8166 1.36898 10.4511 1.00781 10.0001 1.00781C9.54908 1.00781 9.18353 1.36898 9.18353 1.81451V6.11689C9.18353 6.56242 9.54908 6.92359 10.0001 6.92359C10.4511 6.92359 10.8166 6.56242 10.8166 6.11689V1.81451Z",
    fill: "#F6821F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5445 3.39252C16.2255 3.07749 15.7085 3.07749 15.3896 3.39252C15.0708 3.70756 15.0708 4.21833 15.3896 4.53336C16.4555 5.58634 17.1814 6.9279 17.4754 8.38837C17.7695 9.84893 17.6186 11.3628 17.0418 12.7386C16.4649 14.1143 15.488 15.2902 14.2348 16.1176C12.9814 16.9448 11.5079 17.3865 10.0006 17.3865C8.49321 17.3865 7.01971 16.9448 5.76638 16.1176C4.51306 15.2902 3.53622 14.1143 2.95938 12.7386C2.38254 11.3629 2.23161 9.84893 2.52568 8.38847C2.81974 6.92791 3.5456 5.58635 4.61146 4.53337C4.93036 4.21834 4.93036 3.70757 4.61146 3.39253C4.29257 3.0775 3.77554 3.0775 3.45666 3.39253C2.1624 4.67114 1.281 6.30019 0.923915 8.07372C0.566836 9.84718 0.750106 11.6854 1.45056 13.356C2.15101 15.0266 3.33718 16.4545 4.85907 17.4591C6.38095 18.4636 8.17023 18.9998 10.0006 18.9998C11.8309 18.9998 13.6202 18.4636 15.142 17.4591C16.664 16.4545 17.8501 15.0266 18.5506 13.356C19.251 11.6854 19.4343 9.84718 19.0772 8.07362C18.7201 6.30018 17.8387 4.67113 16.5445 3.39252Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerbutton);
export default __webpack_public_path__ + "static/media/powerbutton.403cc0760e61aa4bd8a877e3edb33aee.svg";
export { ForwardRef as ReactComponent };